import { action } from 'typesafe-actions'
import { SwitchColorModePayload, ThemeTypes } from './types'

export const switchColorMode = (payload: SwitchColorModePayload): any =>
  action(ThemeTypes.SWITCH_COLOR_MODE, payload)
